var _require = require("./remark-typograf"),
    remarkTypograf = _require.remarkTypograf;

module.exports = remarkTypograf;